<template>
  <div
    :class="{ 'flexibleSliderSection--loading': loading }"
    class="flexibleSliderSection container"
  >
    <div class="flexibleSliderSection__header">
      <component :is="hTag ? 'h2' : 'span'" class="flexibleSliderSection__headerTitle">
        {{ section.title }}
      </component>
      <border-link
        v-if="section.link"
        class="flexibleSliderSection__headerLink"
        :to="section.link.url"
        :text="section.link.text"
      />
    </div>
    <div class="flexibleSliderSection__inner">
      <slider-tiles
        :content-type="contentType"
        :items="section.data.products"
        slides-per-view="auto"
        :disable-native-link="disableNativeLink"
      />
    </div>
    <div v-if="section.link" class="flexibleSliderSection__mobileLink">
      <border-link :to="section.link.url" :text="section.link.text" />
    </div>
    <loader v-if="loading" />
  </div>
</template>

<script>
import BorderLink from '~/components/BorderLink';
import Loader from '~/components/Loader';
import SliderTiles from '~/components/Sliders/SliderTiles';

export default {
  name: 'FlexibleSliderSection',
  components: {
    Loader,
    BorderLink,
    SliderTiles,
  },
  props: {
    disableNativeLink: {
      type: Boolean,
      default: false,
    },
    contentType: {
      type: String,
      default: 'product',
    },
    section: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hTag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.flexibleSliderSection {
  $root: &;
  position: relative;
  margin-top: 4rem;
  padding-top: 2rem;
  transition: opacity $tr;

  @include rwd('ultra') {
    padding-top: 1rem;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__headerTitle {
    margin-bottom: 3rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;

    @include rwd('tablet') {
      width: 100%;
      text-align: center;
      font-size: 3rem;
      line-height: 3.8rem;
    }
  }

  &__headerLink {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__inner {
  }

  &__mobileLink {
    display: none;

    @include rwd('tablet') {
      display: block;
      padding-top: 2.2rem;
      text-align: center;
    }
  }

  &--loading {
    opacity: 0.6;
    min-height: 52rem;

    @include rwd('laptop') {
      min-height: 40rem;
    }
  }
}
</style>
